const ConstantsPages = {
  PAGE_WELCOME: "/",
  PAGE_FILTER: "/page-filter",
  PAGE_TERMINAL_INFO: "/page-terminal-info",
  PAGE_MODEL_INFO: "/page-model-info",
  PAGE_DASHBOARD: "/page-dashboard",
};

export default ConstantsPages;
